import { render, staticRenderFns } from "./event-form-builder.vue?vue&type=template&id=2cf1437a&scoped=true&"
import script from "./event-form-builder.vue?vue&type=script&lang=js&"
export * from "./event-form-builder.vue?vue&type=script&lang=js&"
import style0 from "./event-form-builder.vue?vue&type=style&index=0&id=2cf1437a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf1437a",
  null
  
)

export default component.exports